import { GetPodcastMetricsByDayArgs } from 'api';
import { useDailyPodcastMetrics } from 'pages/Play/state';
import React from 'react';
import * as S from './styles';
import { columns, defaultSort } from './utils';

interface PodcastMetricsByDayTableProps
  extends Omit<GetPodcastMetricsByDayArgs, 'podcastId'> {}

const PodcastMetricsByDayTable: React.FC<PodcastMetricsByDayTableProps> = (
  props,
) => {
  const { remoteEpisodeId, startMillis, endMillis } = props;
  const {
    data = [],
    isError,
    isLoading,
  } = useDailyPodcastMetrics({
    startMillis,
    endMillis,
    remoteEpisodeId,
  });

  return (
    <S.DailyStatsTable
      title="Daily breakdown for this period"
      dailyStats={{ data, error: isError, loading: isLoading }}
      columns={columns}
      defaultSort={defaultSort}
      reportType="PlayDailyStats"
      exportArgs={{ fileName: 'Play_daily_stats' }}
    />
  );
};
export default PodcastMetricsByDayTable;
